import { formatMoney } from '@theme/money-formatting';

/** @type {Promise<void> | undefined} */
let moneyReadyPromise;

/**
 * Resolves when client-side money formatting is available.
 *
 * @returns {Promise<void>}
 */
window.fitnWhenMoneyReady = function fitnWhenMoneyReady() {
  if (typeof window.fitnFormatMoney === 'function') {
    return Promise.resolve();
  }

  if (!moneyReadyPromise) {
    moneyReadyPromise = new Promise(function (resolve) {
      if (typeof window.fitnFormatMoney === 'function') {
        resolve();
        return;
      }

      document.addEventListener('fitn:money-ready', function onReady() {
        document.removeEventListener('fitn:money-ready', onReady);
        resolve();
      });
    });
  }

  return moneyReadyPromise;
};

/**
 * Formats cents using the active Shopify money format template.
 *
 * @param {number|string} cents
 * @param {string} [format]
 * @param {string} [currency]
 * @returns {string}
 */
window.fitnFormatMoney = function fitnFormatMoney(cents, format, currency) {
  const moneyFormat = format || '${{amount}}';
  const activeCurrency =
    currency ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'USD';

  let formatted = '';

  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    const shopifyFormatted = window.Shopify.formatMoney(cents, moneyFormat);
    if (shopifyFormatted && !shopifyFormatted.includes('{{')) {
      formatted = shopifyFormatted;
    }
  }

  if (!formatted) {
    formatted = formatMoney(Number(cents), moneyFormat, activeCurrency);
  }

  return withAedSymbol(formatted, activeCurrency);
};

/**
 * AED money formats often omit the dirham symbol. Prefix it when it is missing.
 * Directional isolates keep د.إ in the correct order beside the amount.
 *
 * @param {string} formatted
 * @param {string} currency
 * @returns {string}
 */
function withAedSymbol(formatted, currency) {
  if (!formatted || String(currency).toUpperCase() !== 'AED') return formatted;
  if (formatted.includes('\u062F')) return formatted;

  return '\u2067\u062F.\u0625\u2069\u00a0' + formatted;
}

document.dispatchEvent(new CustomEvent('fitn:money-ready'));
